import React, { useState, useEffect } from "react";
import NavbarComponent from "./DashboardNavbar.js";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import RecommendationComponent from "./RecommendClothing.js";
import "./Dashboard.css";

const API_URL = process.env.REACT_APP_API_URL_EC2;

const Dashboard = () => {
  const [storedUser, setStoredUser] = useState(null);
  const [mrn, setMrn] = useState();

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (storedUserData) {
      const data = JSON.parse(storedUserData);
      setStoredUser(data);
      if (data.id) {
        setMrn(data.id);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []);

  const onDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData();
      }
    });
  };

  const deleteData = async () => {
    const response = await axios.post(`${API_URL}/api/DeleteAllData`, { mrn });

    if (response.data.success) {
      Swal.fire("Success", "Account deleted successfully!", "success").then(
        () => {
          sessionStorage.removeItem("user");
          window.open("/login", "_self");
        }
      );
    } else {
      Swal.fire("Error", response.data.message, "error");
    }
  };

  return (
    <Container fluid className="dashboard-container">
      <Row>

        {/* Main Content */}
        <Col md={12} className="main-content">
          <NavbarComponent />
          <div className="dashboard-content">
         <RecommendationComponent/>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const DashboardCard = ({ title, text, image, link, buttonText }) => (
  <Card className="dashboard-card">
    <Card.Img variant="top" src={image} height="305px" />
    <Card.Body>
      <Card.Title>{title}</Card.Title>
      <Card.Text>{text}</Card.Text>
      <Button variant="primary" onClick={() => window.open(link, "_self")}>
        {buttonText}
      </Button>
    </Card.Body>
  </Card>
);

export default Dashboard;
